import { render, staticRenderFns } from "./ProcessosAtaDirex.vue?vue&type=template&id=53acefa8"
import script from "./ProcessosAtaDirex.vue?vue&type=script&lang=js"
export * from "./ProcessosAtaDirex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports